import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { FiX, FiLock } from 'react-icons/fi';
import { changePassword } from '../services/api';
import Toast from './Toast';

const ChangePasswordModal = ({ open, onClose }) => {
  const { t } = useTranslation();
  const [form, setForm] = useState({ currentPassword: '', newPassword: '', confirm: '' });
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState('');
  const [toast, setToast] = useState(null);

  const reset = () => {
    setForm({ currentPassword: '', newPassword: '', confirm: '' });
    setError('');
  };

  const close = () => { reset(); onClose && onClose(); };

  const setNum = (field) => (e) => {
    setForm(p => ({ ...p, [field]: e.target.value.replace(/\D/g, '') }));
  };

  const submit = async () => {
    setError('');
    if (!form.currentPassword) return setError('Enter your current password');
    if (!/^\d{4,}$/.test(form.newPassword)) return setError('New password must be at least 4 digits, numbers only');
    if (form.newPassword !== form.confirm) return setError('New passwords do not match');
    if (form.newPassword === form.currentPassword) return setError('New password must be different from current');
    setSaving(true);
    try {
      await changePassword({ currentPassword: form.currentPassword, newPassword: form.newPassword });
      setToast({ msg: 'Password changed successfully', type: 'success' });
      setTimeout(() => { setToast(null); close(); }, 1200);
    } catch (e) {
      setError(e.response?.data?.error || 'Failed to change password');
    } finally { setSaving(false); }
  };

  if (!open) return null;

  return (
    <>
      <div className="modal-overlay" onClick={close} style={{ alignItems: 'center', justifyContent: 'center', padding: 16 }}>
        <div className="modal" style={{ maxWidth: 420, width: '100%' }} onClick={e => e.stopPropagation()}>
          <div className="modal-header">
            <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
              <FiLock />
              <h3>{t('auth.changePassword')}</h3>
            </div>
            <button className="btn-icon" onClick={close}><FiX /></button>
          </div>
          <div className="modal-body">
            {error && <div className="error-msg" style={{ marginBottom: 12 }}>{error}</div>}
            <div className="form-group">
              <label>{t('auth.currentPassword')} <span className="required">*</span></label>
              <input type="password" value={form.currentPassword}
                onChange={e => setForm(p => ({ ...p, currentPassword: e.target.value }))}
                autoComplete="current-password" />
            </div>
            <div className="form-group">
              <label>{t('auth.newPassword')} <span className="required">*</span> <span style={{ fontWeight: 400, fontSize: 11, color: '#9ca3af' }}>(min 4 digits, numbers only)</span></label>
              <input type="password" inputMode="numeric" pattern="[0-9]*" maxLength={20}
                value={form.newPassword} onChange={setNum('newPassword')}
                autoComplete="new-password" />
            </div>
            <div className="form-group">
              <label>Confirm New Password <span className="required">*</span></label>
              <input type="password" inputMode="numeric" pattern="[0-9]*" maxLength={20}
                value={form.confirm} onChange={setNum('confirm')}
                autoComplete="new-password" />
            </div>
          </div>
          <div className="modal-footer">
            <button className="btn btn-secondary" onClick={close}>{t('common.cancel')}</button>
            <button className="btn btn-primary" onClick={submit} disabled={saving}>
              {saving ? t('common.saving') : t('auth.changePassword')}
            </button>
          </div>
        </div>
      </div>
      <Toast message={toast?.msg} type={toast?.type} onClose={() => setToast(null)} />
    </>
  );
};

export default ChangePasswordModal;
